const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || "https://nyklbdnlhmbainligpcl.supabase.co";

export const SYSTEM_ASSETS = {
  get logoUrl() {
    return `${supabaseUrl}/storage/v1/object/public/chat-attachments/system/main-logo.png`;
  },
  get chatBackgroundUrl() {
    return `${supabaseUrl}/storage/v1/object/public/chat-attachments/system/chat-bg.png`;
  },
  get receiptLogoUrl() {
    return `${supabaseUrl}/storage/v1/object/public/chat-attachments/system/receipt-logo.png`;
  },
  get receiptBackgroundUrl() {
    return `${supabaseUrl}/storage/v1/object/public/chat-attachments/system/receipt-bg.png`;
  }
};
